import React from 'react';
import { RightPanelContainer } from './styles';
var TicketRightPanel = function (_a) {
    var ticket = _a.ticket, children = _a.children, _b = _a.fullHeight, fullHeight = _b === void 0 ? false : _b;
    return React.createElement(RightPanelContainer, { fullHeight: fullHeight }, children);
};
export default TicketRightPanel;
